import { inViewFadeUp } from '@helpers/animate';
import brand from '@helpers/brand';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { contentStyles, h3, h4, cardHeadingUnderlineAnimate } from '@helpers/typography';
import SectionWrapper from '@stories/Components/SectionWrapper/SectionWrapper';
import { mix } from 'polished';
import styled, { css } from 'styled-components';
const Container = styled(SectionWrapper) `
  background: var(--bgColor);
  color: var(--fgColor);

  &[data-bg='white'] {
    --bgColor: ${brand.white};
    --fgColor: ${brand.black};
    margin: var(--sectionSpacing) 0;
  }

  &:not([data-bg='white']) {
    padding: var(--sectionSpacing) 0;

    blockquote:before {
      background-color: currentColor;
    }
  }

  &[data-bg='lightGrey'] {
    --bgColor: ${mix(0.25, brand.grey.otherGrey, brand.white)};
    --fgColor: ${brand.black};
  }

  &[data-bg='grey'] {
    --bgColor: ${brand.grey.grey3};
    --fgColor: ${brand.black};
  }

  &[data-bg='black'] {
    --bgColor: ${brand.grey.grey6};
    --fgColor: ${brand.white};
  }

  &[data-align='center'] {
    text-align: center;

    blockquote {
      display: inline-block;
    }
  }

  &[data-width='narrow'] {
    background-color: ${brand.white};
  }
`;
const Inner = styled.div `
  [data-align='left'] & {
    ${baseGrid};
  }
`;
function underlineDelay() {
    let styles = '';
    for (let i = 0; i < 6; i += 1) {
        styles += `
        &:is(h${i + 1})::after {
          transition-delay: ${i * 0.3}s;
        }
     `;
    }
    return css `
    ${styles}
  `;
}
const Content = styled.div `
  ${contentStyles}
  margin: 0 auto;
  width: 100%;

  ${inViewFadeUp({ delay: 0.15, duration: 0.3 })};

  [data-align='center'] & {
    max-width: 800px;
  }

  [data-width='narrow'] & {
    max-width: 770px;
  }

  [data-align='left'] & {
    grid-row: 2;
    grid-column: 1 / span 12;
    max-width: 800px; 
    
    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }

  .heading-underline {
    ${h4}
    ${cardHeadingUnderlineAnimate}
    ${underlineDelay()};
  }

  ${({ styles }) => styles &&
    css `
      ${styles}
    `}
`;
const IntroContent = styled.div `
  ${baseGrid};
  width: 100%;
  margin: 0 auto var(--introSpacing);

  [data-align='left'] & {
    grid-row: 1;
    grid-column: 1 / span 12;
    max-width: 800px; 

    @media ${from(Device.DesktopSmall)} {
      grid-column: 2 / span 10;
    }
  }
`;
const Title = styled.h2 `
  ${h3}
  margin-bottom: 16px;
  grid-column: 1 / span 12;
  grid-row: 1;

  @media ${from(Device.TabletLarge)} {
    grid-column: 1 / span 6;
    margin-bottom: 0;
  }

  ${inViewFadeUp({ delay: 0, duration: 0.3 })};
`;
const TopContent = styled.div `
  ${contentStyles};
  grid-column: 1 / span 12;
  grid-row: 2;
  margin: -8px 0 0;

  @media ${from(Device.TabletLarge)} {
    grid-column: 7 / span 6;
    grid-row: 1;
    margin: 0;
  }

  ${IntroContent}:not(:has(h2)) & {
    @media ${from(Device.TabletLarge)} {
      grid-column: 1 / span 12;
    }
  }

  ${inViewFadeUp({ delay: 0, duration: 0.6 })};
`;
const RichTextStyles = {
    Container,
    Content,
    Inner,
    IntroContent,
    Title,
    TopContent,
};
export default RichTextStyles;
